import _ from 'lodash';

import Backbone from 'backbone';
import Radio from 'backbone.radio';
import { Application } from 'backbone.marionette';
import RootLayout from './layouts/Root';
import { HeaderView, MenuView, FooterView, MatchCentreGameBar } from './views';
import { MenuModel, User as UserModel } from './models';
import { isAuthorized, Secret } from '../../core/utils';

import routers from './routers';
import collections from './collections';
const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON);

export default class App extends Application {
	constructor(args) {
		super({
			...args,
			region: '#app'
		});
	}

	_initRouters(params) {
		if (IS_PRE_SEASON) {
			new routers.OffSeasonRouter(params);

			return this;
		}

		_.each(routers, Router => new Router(params));

		return this;
	}

	showCoachPopup() {
		if (isAuthorized()) {
			const
				current_url = Backbone.history.fragment,
				is_team_builder = current_url === 'fantasy/team';

			if (!is_team_builder) {
				return false;
			}

			Radio.channel('coach').trigger('show:popup:smart');
			Backbone.history.off('route', this.showCoachPopup);

			return true;
		}

		return false;
	}

	async onStart() {
		const
			rootView = new RootLayout(),
			headerView = new HeaderView(),
			matchCentreView = new MatchCentreGameBar({
				rounds: new collections.Rounds(),
				squads: new collections.Squads(),
				ladder: new collections.Ladder()
			}),
			menu = new MenuView({
				rounds: new collections.Rounds(),
				model: new MenuModel()
			}),
			footerView = new FooterView();

		rootView.getRegion('menu').show(menu);

		rootView.getRegion('header').show(headerView);
		rootView.getRegion('footer').show(footerView);
		rootView.getRegion('match_centre').show(matchCentreView);

		this._initRouters({ rootView }).showView(rootView);


		if (UserModel.user) {
			await UserModel.update();
		}

		if (!this.showCoachPopup()) {
			Backbone.history.on('route', this.showCoachPopup);
		}
	}
}